export enum StageTypes {
  KNOCK_OUT = 'KNOCK_OUT',
  FRIENDLY = 'FRIENDLY',
  STANDINGS = 'STANDINGS',
  GROUPS = 'GROUPS',
}
